import React from "react";
import "../styles/About.css";

const About = () => {
  return (
    <div className="about-container">
      <h1 className="title">Shri Kheteshwar Gurukul: A Legacy of Knowledge & Devotion</h1>
      <img src="/aboutimg.jpeg" alt="Shri Kheteshwar Gurukul" className="main-image" />
      
      <div className="history">
        <h2>The Beginning of a Spiritual Legacy</h2>
        <img src="/kheteshwarM.png" alt="Sant Shri Kheteshwar Maharaj" className="section-image" />
        <p>
          The foundation of Shri Kheteshwar Gurukul is deeply rooted in spiritual wisdom. 
          **Sant Shri Kheteshwar Maharaj**, a revered saint and guiding light, laid the philosophical and spiritual 
          foundation upon which the Gurukul stands today. His teachings and blessings continue to illuminate the path 
          for countless students, ensuring that the traditions of Sanatan Dharma remain strong.
        </p>

        <h2>Guidance & Knowledge: The Role of Guru and Scholar</h2>
        <img src="06.jpg" alt="Guru Lineage" className="section-image" />
        <p>
          **Tulcharam Ji Maharaj**, a devoted disciple of **Sant Shri Kheteshwar Maharaj**, dedicated his life to preserving 
          Vedic traditions and the Gurukul system. While he was not formally educated in modern academics, his spiritual 
          wisdom and guidance were instrumental in shaping the path for future generations. 
        </p>
        <p>
          Under his divine guidance, **Vedantacharya Dhyanaram Ji Maharaj**, an exceptional scholar, pursued higher education in **Kashi**, 
          the sacred seat of learning in ancient India. Excelling in multiple disciplines, he earned **gold medals** for his mastery 
          in Vedic studies and modern academic fields. With a vision to restore the Gurukul tradition, he laid the foundation for **Brahmrishi Kheteshwar Ved Vigyan Gurukul** 
          in **Mayalwas, Balotra (Jujhan Nadi) in 2016-17**. 
        </p>

        <h2>Expansion: Establishing Centers of Excellence</h2>
        <img src="/abc.png" alt="Gurukul Expansion" className="section-image" />
        <p>
          Understanding the need for holistic education rooted in culture and wisdom, more Gurukuls were established:
        </p>
        <ul>
          <li><strong>Bijrol Kheda, Jalore (2020)</strong> - The birthplace of Sant Shri Kheteshwar Maharaj, preserving his teachings.</li>
          <li><strong>Tura Sayala, Jalore (2022)</strong> - A day-boarding Gurukul providing quality education in a nurturing environment.</li>
          <li><strong>Choti Sawaai, Churu (2024)</strong> - The latest addition, ensuring the spread of traditional learning.</li>
        </ul>

        <h2>A Holistic Learning Environment</h2>
        <img src="/smartboard.png" alt="Gurukul Classroom" className="section-image" />
        <p>
          The Gurukuls follow a **unique teaching methodology**, combining **Smart Boards** with an immersive **Vedic learning atmosphere**. 
          The serene environment instills **discipline, devotion, and a deep-rooted connection with Sanatan Dharma**.  
        </p>

        <h2>Facilities & Cultural Preservation</h2>
        <img src="/gaushala.png" alt="Gaushala at Mayalwas" className="section-image" />
        <p>
          Our Gurukuls offer more than just education; they provide **a complete way of life**:
        </p>
        <ul>
          <li><strong>Boarding Facilities</strong> - Mayalwas and Bijrol Kheda host students with full residential support.</li>
          <li><strong>Gaushala (Cow Shelter)</strong> - The Mayalwas Gurukul recently established a **Gaushala housing 50-60 cows**.</li>
          <li><strong>Hydroponic Farming</strong> - Fresh vegetables are cultivated in an **eco-friendly** manner.</li>
          <li><strong>Cultural Education</strong> - Students learn **Vedas, Yoga, and Shastra**, ensuring a deep **cultural and spiritual bond**.</li>
        </ul>

        <h2>Social Welfare & Support</h2>
        <img src="/abrsvs.jpeg" alt="abrsvs" className="section-image" />
        <p>
          All Gurukuls operate under the administration of **Akhil Bhartiya Rajpurohit Samaj Vikas Sansthan, Asotra**.
          To ensure that education reaches everyone, a noble initiative, the **Samaj Shiksha Nidhi Samarpan Yojana**, was started
          under the leadership of **Dhyanaram Ji Maharaj**, with the **spiritual guidance of Tulcharam Ji Maharaj**. This program ensures:
        </p>
        <ul>
          <li>**Free education for orphans and underprivileged children**.</li>
          <li>Financial assistance for students in need.</li>
          <li>Continued **support for Gurukul development**.</li>
        </ul>
      </div>
    </div>
  );
};

export default About;
